import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { LoadingIndicatorComponent, LoginNavigationService, NativeAppService, WINDOW } from '@frontend/vanilla/core';

import { LoginIntegrationConfig } from './login-integration.client-config';

@Component({
    imports: [LoadingIndicatorComponent],
    selector: 'lh-danske-spil-login-success',
    templateUrl: 'danske-spil-login-success.html',
})
export class DanskeSpilLoginSuccessComponent implements OnInit {
    readonly #window = inject(WINDOW);
    private readonly navigation = inject(LoginNavigationService);
    private readonly config = inject(LoginIntegrationConfig);
    private readonly nativeAppService = inject(NativeAppService);
    private readonly destroyRef = inject(DestroyRef);

    private get usedWindow(): Window {
        return this.config.options.version === 2 ? this.#window : this.#window.parent;
    }

    ngOnInit() {
        this.config.whenReady.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            const redirectUrl = this.navigation.getStoredLoginRedirect(false).url;

            if (this.config.options.version !== 2 && this.nativeAppService.isDownloadClient && redirectUrl) {
                this.usedWindow.location.href = redirectUrl.absUrl();
            }
        });
    }
}
